const RENEWAL = "renewal",
	  CLAIMS = "claims",
	  PAY_BALANCE = "paybalance",
	  DOCUMENT_SUBMIT = "document-submit",
	  POLICY_MANAGER = "manage-your-policy",
	  QUICK_PAY = "quick-pay",
	  POLICY_REWRITE = "Policy Rewrite",
	  TRACK_A_CLAIM = "track-my-claim";
export { RENEWAL, CLAIMS, PAY_BALANCE, DOCUMENT_SUBMIT, POLICY_MANAGER, QUICK_PAY, TRACK_A_CLAIM, POLICY_REWRITE };
